import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ReggieProvider } from "./context/ReggieContext";
import { ProtectedRoute, PublicRoute } from "./components/ProtectedRoute";
import { ReggieChat } from "./components/ReggieChat";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import PathView from "./pages/PathView";
import StepExecution from "./pages/StepExecution";
import Workspace from "./pages/Workspace";
import Projects from "./pages/Projects";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import Docs from "./pages/Docs";
import BillingSettings from "./pages/BillingSettings";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";

function App() {
  return (
    <AuthProvider>
      <ReggieProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Protected routes - Onboarding */}
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute requireOnboarding={false}>
                <Onboarding />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - Main app */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspace"
            element={
              <ProtectedRoute>
                <Workspace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/path/:pathId"
            element={
              <ProtectedRoute>
                <PathView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/path/:pathId/step/:stepNumber"
            element={
              <ProtectedRoute>
                <StepExecution />
              </ProtectedRoute>
            }
          />

          {/* Admin route */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />

          {/* Public help center / guides */}
          <Route path="/docs" element={<Docs />} />
          <Route path="/help" element={<Navigate to="/docs" replace />} />
          <Route path="/guides" element={<Navigate to="/docs" replace />} />

          {/* Subscription routes */}
          <Route path="/pricing" element={<Pricing />} />
          <Route
            path="/settings/billing"
            element={
              <ProtectedRoute>
                <BillingSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription/success"
            element={
              <ProtectedRoute>
                <SubscriptionSuccess />
              </ProtectedRoute>
            }
          />

          {/* Public marketing landing (redirects authed users to /dashboard) */}
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ReggieChat />
      </BrowserRouter>
      </ReggieProvider>
    </AuthProvider>
  );
}

export default App;
